import React from 'react';
import ReactDOM from 'react-dom';
import App from './Senate';

window.renderElections = (id, props = {}) => {
	const root = document.getElementById(id);
	ReactDOM.render(
		<App {...props} />,
		root
	);
};
